// Translations
import server from './server'

// Translation: German > Notices
const notices = Object.freeze({
	error: {
		client: {
			appleSignInPopupBlockedError: '',
			appleSignUpPopupBlockedError: '',
			applicationTokenFetchingError: '',
			capthchaExpiredError: '',
			capthchaNotLoadedError: '',
			emailVerificationCodeResendingError: '',
			passwordResetCodeResendingError: '',
			passwordResetError: '',
			passwordResetRequestError: '',
			providerAuthenticationError: '',
			registrationError: '',
			unavailableCaptchaTokenError: '',
			verificationError: ''
		},
		fallback: '',
		server: server.errorItems
	},
	success: {
		fallback: '',
		passwordChangeSuccess: ''
	},
	warning: {
		form: {
			hasAtLeast8CharactersWarning: '',
			hasLowerCaseLetterWarning: '',
			hasMatchingValueWarning: '',
			hasNonEmptyValueWarning: '',
			hasNumberWarning: '',
			hasSpecialCharacterWarning: '',
			hasUnusedValueWarning: '',
			hasUpperCaseLetterWarning: '',
			isEmailWarning: '',
			isPersonNameWarning: '',
			isPhoneNumberWarning: '',
			isURLWarning: ''
		}
	}
})

// Export
export default notices
